
import { Component } from "vue-property-decorator";
import Vue from "vue";
import MRListHandler from "./MRListHandler.vue";

@Component({
  components: { MRListHandler },
})
export default class MRListPage extends Vue {}
